<app-edit-vip-settings></app-edit-vip-settings>
